<template>
    <div class="pb-6">        
        <p class="mb-4 max-w-lg text-lg">For your widgets to load correctly, you'll need to provide the exact domain where you want to display them.</p>
        <p class="mb-4 max-w-lg" >Enter the address of the domain (i.e. hostname) where you want your widgets to be displayed.</p>        
        <vs-input name="Main domain" v-validate="'url|required'" size="large" class="w-full" placeholder="I.e. 'https://www.mydomain.com'" v-model="domainBaseLocal"/>
        <span v-if="errors.first('Main domain')" class="block my-4 text-danger">{{errors.first('Main domain')}}</span>
        <vs-checkbox class="my-4" v-model="hasSubs">Also display widgets on subdomains</vs-checkbox>
        <div>
            <p class="mb-4 max-w-md">Enter any subdomains where your widgets will be displayed.</p>
            <div class="flex items-center my-4 block w-full" v-for="(sub,i) in subs" :key="String(i) + sub + 'subd'">
                <vs-input v-model="sub.text"/>
                <span class="inline-block pl-2 mr-2"> .{{ domainBase }} </span> 
                <vs-button type="border" @click="subs.splice(i,1)" icon-pack="feather" icon="icon-trash"></vs-button>
            </div>            
            <vs-button type="border" v-if="hasSubs && subs.length < 11" @click="subs.push({text:''})" icon-pack="feather" icon="icon-plus-circle" icon-after>Add subdomain</vs-button>
        </div>
    </div>
</template>

<script>

/*

Load entity based state on load or when entity.showcase is changed.

*/

export default {
    props: {
        domainSettingsUpdated: Function
    },
    data() {
        return {
            domainBaseLocal: '',
            domainBase: '',
            hasSubs: false,
            subs: []
        }
    },
    created() {
        this.initData()
    },
    watch: {
        domainBaseLocal(v) {
            try {
                if (v.indexOf('https://') === - 1 && v.indexOf('http://') === - 1) v = 'https://' + v                
                const urlO = new URL(v)
                this.domainBase = urlO.hostname.replace('https://', '').replace('http://', '').replace('www.','')
            } catch (e) {
                this.domainBase = ''
            }                        
        },
        domainBase() {  
            this.updateParent()          
        },
        subs: {
            deep: true,
            handler(v) {
                v.forEach((sub, i) => {
                    this.subs[i].text = sub.text.replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
                })
                this.updateParent()
            }
        }, 
        hasSubs(v) {
            if (v) {
                if (this.subs.length === 0) this.subs = [{text:''}, {text:''}]
            } else {
                this.subs = []
            }
            this.updateParent()
        },
        '$store.state.dash.viewData.business.showcase': {
            deep: true,
            handler() {
                this.initData()
            }
        }
    },
    methods: {
        updateParent() {
            this.domainSettingsUpdated({
                domainBase: this.domainBase,
                subs: this.subs
            })
        },
        initData() {
            const oSettings = this.$store.getters['dash/showcaseOriginSets']
            if (oSettings) {        
                    //we only allow one origin sets for UI. We can always add more on B/E.
                    this.domainBaseLocal = oSettings[0].domainBase
                    this.subs = [...oSettings[0].subs.map(sub => {return {text: sub}})]

                    if (this.subs.length > 0) this.hasSubs = true

            }
        }  
    }
}

</script>
